"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecentHistory = void 0;
const list_1 = require("client/components/list");
const text_button_1 = require("client/components/ui/text-button");
const React = require("react");
const react_1 = require("react");
require("./recent-history.less");
class RecentHistory extends react_1.Component {
    render() {
        const data = this.props.data;
        return (React.createElement("div", { className: "recent-history-body" },
            React.createElement("div", { className: "recent-history-title" },
                React.createElement("div", { className: "recent-history-title-content" }, "Recent history"),
                React.createElement(text_button_1.UiTextButton, { className: "view-all" }, "View all history")),
            React.createElement("div", { className: "recent-history-content" }, this.renderList(data))));
    }
    renderList(data) {
        return (React.createElement("div", { className: "list" },
            React.createElement(list_1.List, { data: data, renderRow: this.renderListRow })));
    }
    renderListRow(row, index) {
        return (React.createElement("div", { className: "list-component__row", key: index },
            React.createElement("div", { className: "list-component__column--profile" },
                React.createElement("div", { className: "value" },
                    React.createElement(text_button_1.UiTextButton, null, row.displayName)),
                React.createElement("div", { className: "label" }, row.date)),
            React.createElement("div", { className: "list-component__column--actions" },
                React.createElement("div", { className: "action" }, row.action))));
    }
}
exports.RecentHistory = RecentHistory;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/recent-history/recent-history.tsx
// module id = 3646
// module chunks = 0